// Contrat SS6 lu sur self-service-ss6 ; types locaux en attendant sa fusion, sans modifier le schéma généré.
import { refusInscription } from '../domaine/inscription';
export interface DefiTravail { defi: string; bits: number; expire_s: number }
export interface TexteConditions { document: 'cgv' | 'dpa' | 'confidentialite'; version: string; titre: string; empreinte: string; texte: string; provisoire: boolean }
export interface EtatInscription {
  entreprise: string; siren: string; raison_sociale: string; offre: string; etat: string; prochaine_etape: string;
  conditions: { document: string; version: string; empreinte: string; acceptee: boolean }[];
  paiement: { mode: 'stripe' | 'facture'; sur_facture: boolean };
}
export interface DemandeInscription { courriel: string; nom: string; siren: string; offre: 'diagnostic' | 'abonnement'; pouvoir_engager: boolean; defi: string; solution: string }
export class ClientInscription {
  private session: string | null = null;
  private expiration = 0;
  constructor(private readonly recuperer: typeof fetch = (...args) => fetch(...args)) {}
  oublier(): void { this.session = null; this.expiration = 0; }
  private async appeler<T>(chemin: string, corps?: unknown, entetes?: Record<string, string>): Promise<T> {
    if (this.session && Date.now() >= this.expiration * 1000) this.oublier();
    const headers = new Headers(entetes);
    if (this.session && !entetes) headers.set('Authorization', `Bearer ${this.session}`);
    if (corps !== undefined) headers.set('Content-Type', 'application/json');
    let r: Response;
    try {
      r = await this.recuperer(`/v0/${chemin}`, { method: corps === undefined ? 'GET' : 'POST', headers,
        ...(corps === undefined ? {} : { body: JSON.stringify(corps) }), cache: 'no-store', credentials: 'omit', redirect: 'error', referrerPolicy: 'no-referrer' });
    } catch { throw new Error('Le service est injoignable. Réessayez plus tard.'); }
    if (!r.ok) {
      if (r.status === 401 && !entetes) this.oublier();
      const e = await r.json().catch(() => ({})) as { code?: string };
      throw new Error(refusInscription(e.code ?? 'inconnu'));
    }
    return r.json() as Promise<T>;
  }
  defi(): Promise<DefiTravail> { return this.appeler('inscription/defi'); }
  demander(corps: DemandeInscription): Promise<unknown> { return this.appeler('inscription/demandes', corps); }
  async verifier(jeton: string): Promise<EtatInscription> {
    this.oublier();
    const r = await this.appeler<{ session: string; expire_s: number; etat: EtatInscription }>('inscription/verification', { jeton });
    this.session = r.session; this.expiration = r.expire_s; return r.etat;
  }
  etat(): Promise<EtatInscription> { return this.appeler('inscription/etat'); }
  conditions(): Promise<TexteConditions[]> { return this.appeler('inscription/conditions'); }
  accepter(textes: TexteConditions[]): Promise<EtatInscription> {
    return this.appeler('inscription/conditions/acceptations', { acceptations: textes.map(({ document, version, empreinte }) => ({ document, version, empreinte })) });
  }
  payer(): Promise<{ mode: 'stripe' | 'facture'; url: string | null }> { return this.appeler('inscription/paiement', {}); }
  portail(entetes: Record<string, string>): Promise<{ url: string }> { return this.appeler('facturation/portail', {}, entetes); }
}
